import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5af2f3e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chatbox-container" }
const _hoisted_2 = { class: "chat-room" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Chat", -1))
const _hoisted_4 = {
  key: 0,
  class: "send-by"
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "input-chatbox" }
const _hoisted_7 = { class: "input-message" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "image-upload" }
const _hoisted_10 = {
  for: "file-input",
  class: "mx-3"
}

import { computed, onMounted, PropType, ref, watch } from 'vue'

import useFirestore, { IParticipant, ISendMessage } from '@/composables/useFirestore'
import { IRoom } from '@/types/interfaces/room.interface'
import { IParticipantInfo } from '@/types/interfaces/participant.interface'
import Message from './Message.vue'
import { IPreviewMessage } from '@/types/interfaces/common.interface'

interface ChatboxEmits {
  (e: 'unread-updated', value: number): void
  (e: 'new-messages', value?: IPreviewMessage): void
  (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Chatbox',
  props: {
  enableChat: {
    type: Boolean,
    default: false,
  },
  room: {
    type: Object as PropType<IRoom>,
    required: true,
  },
  localParticipant: {
    type: Object as PropType<IParticipantInfo>,
    required: true,
  },
},
  emits: ["unread-updated", "new-messages", "close"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
/**
 * Use Composible
 */
const {
  messages,
  chatboxRef,
  isSending,
  setRoomIfNotExist,
  addParticipant,
  onSnapshotMessage,
  sendMessage,
  uploadFileURL,
  deleteMessage,
  unreadMessages,
  newMessages,
} = useFirestore()

const inputFileRef = ref<HTMLInputElement>()
const inputMessage = ref('')
const isUploading = ref(false)

const roomRefId = ref<string>('')
const currentUser = computed<IParticipant>(() => {
  return {
    name: props.localParticipant.name,
    email: props.localParticipant.email,
    avatar: props.localParticipant.avatar,
    // TODO: change role from capabilities???
    role: 'student',
  }
})

watch(
  () => unreadMessages.value,
  (unread) => {
    if (unread) {
      emit('unread-updated', unread.length)
    }
  },
)

watch(
  () => newMessages?.value,
  () => {
    if (newMessages?.value) {
      emit('new-messages', newMessages.value)
    }
  },
  { deep: true },
)

/**
 * Watch
 */
watch(
  () => props.enableChat,
  (nVal) => {
    if (nVal) {
      setTimeout(() => {
        if (chatboxRef?.value) {
          chatboxRef.value.scrollTop = chatboxRef?.value?.scrollHeight
        }
      }, 50)
    }
  },
)
// watch(isSending, (nVal) => {
//   if (nVal) {
//     setTimeout(() => {
//       if (chatboxRef?.value) {
//         chatboxRef.value.scrollTop = chatboxRef?.value?.scrollHeight
//       }
//     }, 50)
//   }
// })

/**
 * Methods
 */
const isSelfMessage = (email: string) => {
  return email === (props.localParticipant.email || 'student@gmail.com')
}
const isShowAvatar = (sendByEmail: string, idx: number) => {
  return idx === 0 || sendByEmail !== messages.value[idx - 1].send_by.email
}
const onSendMessage = async () => {
  if (inputMessage.value && roomRefId.value) {
    try {
      const params: ISendMessage = {
        roomRefId: roomRefId.value,
        message: {
          message: inputMessage.value,
          sendBy: currentUser.value,
          fileURL: '',
          type: 'text',
        },
      }
      inputMessage.value = ''
      await sendMessage(params)
    } catch (error) {
      console.error(error)
    }
  }
}
const onImageIcon = async () => {
  if (!inputFileRef.value || !inputFileRef.value.files) return
  const file = inputFileRef.value.files[0]
  if (file?.name && roomRefId.value) {
    /**
     * upload file url
     */
    isUploading.value = true
    await uploadFileURL({
      roomRefId: roomRefId.value,
      user: currentUser.value,
      file,
    })
    isUploading.value = false
  }
}
const onDeleteMessage = async (msgId: string) => {
  if (!roomRefId.value) return
  await deleteMessage({
    roomRefId: roomRefId.value,
    messageRefId: msgId,
  })
}

/**
 * On Mounted
 */
onMounted(async () => {
  /**
   * create chat room if not exist
   */
  await setRoomIfNotExist({
    spaceRoomId: props.room.id,
    externalRoomId: props.room.externalRoomId,
    name: props.room.name,
  })

  roomRefId.value = props.room.id
  /**
   * add participant into chat room
   */
  await addParticipant({
    participant: currentUser.value,
    roomRefId: props.room.id,
  })
  /**
   * detech a listener messages
   */
  onSnapshotMessage({
    currentUser: currentUser.value,
    roomRefId: props.room.id,
  })
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "close-button _pointer-on-hover",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "close-icon",
          icon: "close",
          "inherit-fill": true,
          height: "26"
        })
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "chatboxRef",
      ref: chatboxRef,
      class: _normalizeClass(["chatbox", _unref(isSending) ? 'is-loading' : ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (msg, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: msg.id,
          class: _normalizeClass(["message-container", isSelfMessage(msg.send_by.email) ? 'owned-message' : ''])
        }, [
          (isShowAvatar(msg.send_by.email, idx) && !isSelfMessage(msg.send_by.email))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(msg.send_by.name), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(Message, {
            msg: msg,
            "is-sending": _unref(isSending) && idx === _unref(messages).length - 1,
            "is-my-self": isSelfMessage(msg.send_by.email),
            onUnsend: ($event: any) => (onDeleteMessage(msg.id))
          }, null, 8, ["msg", "is-sending", "is-my-self", "onUnsend"])
        ], 2))
      }), 128)),
      (isUploading.value)
        ? (_openBlock(), _createBlock(Message, {
            key: 0,
            msg: { message: 'Uploading' },
            "is-sending": isUploading.value,
            "is-my-self": ""
          }, null, 8, ["is-sending"]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputMessage).value = $event)),
          type: "text",
          placeholder: `${_ctx.$t('chat-placeholder')}`,
          onKeyup: _withKeys(onSendMessage, ["enter"])
        }, null, 40, _hoisted_8), [
          [_vModelText, inputMessage.value]
        ]),
        _withDirectives(_createElementVNode("button", {
          class: "send-btn",
          onClick: onSendMessage
        }, [
          _createVNode(_component_SvgIcon, {
            class: "action-icon _pointer-on-hover",
            icon: "send-message",
            "inherit-fill": true,
            height: "26"
          })
        ], 512), [
          [_vShow, inputMessage.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, [
          _createVNode(_component_SvgIcon, {
            class: "action-icon _pointer-on-hover",
            icon: "attach",
            "inherit-fill": true,
            height: "26"
          })
        ]),
        _createElementVNode("input", {
          id: "file-input",
          ref_key: "inputFileRef",
          ref: inputFileRef,
          type: "file",
          accept: "image/*, .pdf, .doc, .docx",
          onChange: onImageIcon
        }, null, 544)
      ])
    ])
  ], 512)), [
    [_vShow, __props.enableChat]
  ])
}
}

})